<!--<b>Verrekenen van verliezen</b>-->
<!--<br/>-->
<!--Een verlies uit een bepaald boekjaar wordt op 2 manieren verrekend:-->
<!--<ul>-->
<!--    <li>Met de belastbare winst uit het voorgaande boekjaar. Dit wordt 'carry back' of 'achterwaartse verliesverrekening'-->
<!--        genoemd.</li>-->
<!--    <li>Met de winsten van volgende boekjaren. Dit wordt 'carry forward' of 'voorwaartse verliesverrekening' genoemd.</li>-->
<!--</ul>-->
<!--<br/><br/>-->
<!--<b>Eerst carry back, dan carry forward</b>-->
<!--<br/>-->
<!--Een verlies wordt eerst verrekend met de winst van het voorgaande jaar. Pas daarna verreken je het verlies met de-->
<!--winsten van de toekomstige jaren.-->

<!--<br/><br/>-->
<!--<b>Vanaf 2022: nieuwe regels verliesverrekening</b>-->
<!--<br/>-->
<!--Voor boekjaren die beginnen op of na 1 januari 2022 gelden nieuwe regels voor verliesverrekening.<br/>-->
<!--Verliezen uit 2022 en later zijn onbeperkt voorwaarts verrekenbaar (carry forward). Dit geldt ook voor verliezen-->
<!--waarvan de boekjaren beginnen op 1 januari 2013 of later en die per eind 2021 nog voorwaarts verrekenbaar zijn.-->
<!--Er kan wel een maximum gelden voor het bedrag van de verrekening met winsten van de jaren 2022 en verder.<br/>-->
<!-- - Is de belastbare winst in 2022 of latere jaren € 1.000.000 of lager? Dan kun je verliezen verrekenen tot maximaal-->
<!--het bedrag van de belastbare winst.<br/>-->
<!-- - Is de belastbare winst in 2022 hoger dan € 1.000.000? Dan mag je in elk geval € 1.000.000 gebruiken voor-->
<!--verliesverrekening. Van de resterende winst mag je 50% gebruiken voor verliesverrekening.-->
<!--<br/><br/>-->

<!--<div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">-->
<!--    <p><u>Voorbeeld</u></p>-->
<!--    Winst 2022: € 9.000.000.<br/>-->
<!--    Verlies 2021: € 7.000.000.<br/>-->
<!--    Van de winst 2022 mag je gebruiken voor verliesverrekening: € 1.000.000 + € 4.000.000 (50% van € 8.000.000) = €-->
<!--    5.000.000.<br/>-->
<!--    De belastbaar bedrag 2022 wordt dan € 9.000.000 - € 5.000.000 = € 4.000.000<br/>-->
<!--    Van het verlies 2021 blijft nog over: € 7.000.000 - € 5.000.000 = € 2.000.000.<br/>-->
<!--    Dit verlies mag u verrekenen met de winsten van 2023 en verder.<br/>-->
<!--</div>-->

<!--<br/>-->
<!--<b>Verlies 2022 verrekenen met winst 2021</b>-->
<!--<br/>-->
<!--Het maximum geldt ook als je een verlies uit 2022 verrekent met de winst van 2021. Voor de voorwaartse verrekening-->
<!--van een verlies van vóór 2021 met de winst uit 2021 geldt deze beperking niet.-->
<!--<br/><br/>-->
<!--<div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">-->
<!--    <p><u>Voorbeeld</u></p>-->
<!--    Verlies 2022: € 9.000.000.<br/>-->
<!--    Winst 2021: € 7.000.000.<br/>-->
<!--    Verlies 2020: € 1.000.000.<br/>-->
<!--    Van de winst 2021 mag je gebruiken voor verliesverrekening: € 1.000.000 + € 3.000.000 (50% van € 6.000.000) = €-->
<!--    4.000.000.<br/>-->
<!--    Het verlies uit 2020 is volledig verrekend met de winst over 2021. Voor deze verliesverrekening geldt geen-->
<!--    beperking.<br/>-->
<!--    De verliesverrekeningsruimte bedraagt € 4.000.000. Er is al een verlies uit 2020 verrekend van € 1.000.000. Hierdoor-->
<!--    kan van het verlies uit 2022 maar een bedrag van € 3.000.000 worden verrekend met de winst over 2021.-->
<!--    het belastbaar bedrag 2021 wordt dan € 7.000.000 - € 1.000.0000 - € 3.000.000 = € 3.000.000.-->
<!--    Van het verlies 2022 blijft nog over: € 9.000.000 - € 3.000.000 = € 6.000.000.-->
<!--    Dit verlies mag je verrekenen met de winsten over 2023 en verder.-->
<!--</div>-->
<!--<br/>-->
<!--<b>Wanneer verliezen niet verrekenen?</b>-->
<!--<br/>-->
<!--In bepaalde situaties gelden speciale voorwaarden voor het verrekenen van verliezen. Je kunt bijvoorbeeld geen-->
<!--verliezen verrekenen in de volgende situaties:-->
<!--<ul>-->
<!--    <li>Er treedt een belangenwijziging in de vennootschap op</li>-->
<!--    <li>Er is sprake van houdsterverliezen.</li>-->
<!--    <li>De fiscale beleggingsinstelling werd in een eerdere periode niet als beleggingsinstelling aangemerkt./li>-->
<!--</ul>-->
<!--<br/><br/>-->
<!--<b>Voorlopige verliesverrekening</b>-->
<!--<br/>-->
<!--Lijdt de onderneming in een jaar verlies? En wil je dit verlies verrekenen met winst uit het voorgaande jaar? Dan hoef je niet te-->
<!--wachten tot de aangifte over het verliesjaar is afgehandeld. Als je de aangifte indient, kun je een schriftelijk-->
<!--verzoek om voorlopige verliesverrekening naar uw belastingkantoor sturen. De Belastingdienst stelt dan de voorlopige-->
<!--verliesverrekening vast met een beschikking. Enkele voorwaarden die hierbij gelden:<br/>-->
<!-- - Je dient de aangifte in over het verliesjaar.<br/>-->
<!-- - De aanslag over het jaar waarmee het verlies wordt verrekend, moet definitief vaststaan.<br/>-->
<!--Van het verlies dat je aangeeft, wordt maximaal 80% verrekend.-->
<!--<br/><br/>-->
<!--Bij het vaststellen van de aanslag over het verliesjaar, houdt de Belastingdienst rekening met de eerdere voorlopige-->
<!--verliesverrekening.-->
<!--<br/><br/>-->
<!--<b>Belangenwijziging</b>-->
<!--<br/>-->
<!--Een belangenwijziging is een verandering in de (middellijke of onmiddellijke) uiteindelijke aandeelhouders van de vennootschap.-->
<!--De uiteindelijke aandeelhouders zijn natuurlijke personen en onder bepaalde omstandigheden ook rechtspersonen.-->
<!--<br/><br/>-->
<!--<b>Verliezen niet langer verrekenbaar bij belangenwijziging</b>-->
<!--<br/>-->
<!--De verliezen zijn niet langer voorwaarts verrekenbaar als het uiteindelijke belang in de vennootschap voor 30% of meer is gewijzigd.-->
<!--Niet langer verrekenen van de verliezen geldt als hoofdregel in de volgende situaties:-->
<!--<br/>-->
<!-- - De bezittingen van de vennootschap bestonden in het verlies- of winstjaar tijdens meer dan 3 maanden voor meer dan 50% uit beleggingen.-->
<!--<br/>-->
<!-- - De activiteiten van de vennootschap zijn direct voor de belangenwijziging afgenomen tot minder dan 30% van de activiteiten bij het begin van het oudste nog te verrekenen verliesjaar.-->
<!--<br/>-->
<!-- - Op het moment van belangenwijziging bestaat het voornemen de activiteiten in de komende 3 jaar te laten inkrimpen tot minder dan 30% van de activiteiten bij het begin van het oudste nog te verrekenen verliesjaar.-->
<!--<br/><br/>-->
<!--Is alleen de 1e situatie van toepassing? Dan kun je een verzoek doen om de verliezen toch nog voorwaarts te verrekenen met de winst uit werkzaamheden die er al waren tijdens de belangenwijziging.-->
<!--<br/><br/>-->
<!--<b>Wanneer geen verrekening met vorig jaar?</b>-->
<!--<br/>-->
<!--Als de vennootschap verlies lijdt na de belangenwijziging, kun je dat verlies in een aantal situaties niet verrekenen met de winst van vóór de belangenwijziging:-->
<!--<br/>-->
<!-- - De activiteiten van de vennootschap zijn gestaakt.<br/>-->
<!-- - De bezittingen van de vennootschap bestonden in het winst- of verliesjaar meer dan 3 maanden voor meer dan 50% uit beleggingen.-->
<!--<br/><br/>-->
<!--Carry back van verliezen is niet mogelijk als in de vennootschap een nieuwe onderneming is gestart, het belang voor meer dan 30% is overgegaan in andere handen.-->
<!--<br/><br/>-->
<!--<b>Winst of verlies van het jaar van de belangenwijziging</b>-->
<!--<br/>-->
<!--In het jaar van de belangenwijziging wordt het resultaat over 2 periodes afzonderlijk berekend. Het gaat om de periode tot aan de belangenwijziging en de resterende periode.-->
<!--Als tot aan de belangenwijziging een verlies is geleden, wordt dat direct aan het voorafgaande jaar toegerekend.-->
<!--En overeenkomstig wordt een verlies ná de belangenwijziging rechtstreeks bij het volgende jaar in aanmerking genomen.-->
<!--<br/><br/>-->
<!--<b>Uitzonderingen</b>-->
<!--<br/>-->
<!--De verliesverrekening wordt bij de volgende belangenwijzigingen niet beperkt:-->
<!--<br/>-->
<!-- - De aandeelhouder is eigenaar geworden van de vennootschap op grond van erfrecht of huwelijksgoederenrecht.<br/>-->
<!-- - De aandeelhouder had aan het begin van het oudste nog te verrekenen verliesjaar al een belang in de vennootschap van minimaal 33 1/3%, en wordt eigenaar van het restant.-->
<!--<br/>-->
<!--<br/>-->
<!--De Belastingdienst stelt de verliezen vast met een beschikking. Tegen deze beschikking kun je bezwaar maken.-->
<!--<br/>-->
<!--<br/>-->
<!--<b>Houdsterverliezen</b>-->
<!--<br/>-->
<!--Een houdsterverlies is het verlies van een houdster- of financieringsmaatschappij. Je kunt een verlies alleen verrekenen met winsten over jaren waarin de vennootschap ook als houdster- of financieringsmaatschappij actief bent.-->
<!--<br/><br/>-->
<!--<b>Voorwaarden verliesverrekening</b>-->
<!--<br/>-->
<!--Voor het jaar waarvan de winst voor verrekening wordt gebruikt, geldt bovendien het volgende:<br/>-->
<!-- - De boekwaarde van het saldo van de vorderingen en schulden op verbonden lichamen mag gedurende (bijna) het gehele boekjaar niet hoger zijn dan de boekwaarde van hetzelfde saldo aan het einde van het verliesjaar.-->
<!--<br/>-->
<!-- - Kun je aannemelijk maken dat de wijziging van het saldo niet overwegend is gericht op de verruiming van de verliesverrekening? Dan kan worden afgeweken van de voorwaarde dat het saldo van het boekjaar niet hoger mag zijn dan het saldo aan het einde van het verliesjaar.-->
<!--<br/><br/>-->
<!--De Belastingdienst stelt het saldo van de vorderingen en schulden op verbonden lichamen aan het einde van het verliesboekjaar vast met een beschikking. Tegen deze beschikking kun je bezwaar maken.-->

<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="true" aria-controls="collapse1">
                Verrekenen van verliezen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Een verlies uit een bepaald boekjaar wordt op 2 manieren verrekend:
                <ul>
                    <li>Met de belastbare winst uit het voorgaande boekjaar. Dit wordt 'carry back' of 'achterwaartse verliesverrekening'
                        genoemd.</li>
                    <li>Met de winsten van volgende boekjaren. Dit wordt 'carry forward' of 'voorwaartse verliesverrekening' genoemd.</li>
                </ul>

                <b>Eerst carry back, dan carry forward</b>
                <br/>
                Een verlies wordt eerst verrekend met de winst van het voorgaande jaar. Pas daarna verreken je het verlies met de
                winsten van de toekomstige jaren.
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Vanaf 2022: nieuwe regels verliesverrekening
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voor boekjaren die beginnen op of na 1 januari 2022 gelden nieuwe regels voor verliesverrekening.<br/>
                Verliezen uit 2022 en later zijn onbeperkt voorwaarts verrekenbaar (carry forward). Dit geldt ook voor verliezen
                waarvan de boekjaren beginnen op 1 januari 2013 of later en die per eind 2021 nog voorwaarts verrekenbaar zijn.
                Er kan wel een maximum gelden voor het bedrag van de verrekening met winsten van de jaren 2022 en verder.<br/>
                - Is de belastbare winst in 2022 of latere jaren € 1.000.000 of lager? Dan kun je verliezen verrekenen tot maximaal
                het bedrag van de belastbare winst.<br/>
                - Is de belastbare winst in 2022 hoger dan € 1.000.000? Dan mag je in elk geval € 1.000.000 gebruiken voor
                verliesverrekening. Van de resterende winst mag je 50% gebruiken voor verliesverrekening.
                <br/><br/>

                <div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <p><u>Voorbeeld</u></p>
                    Winst 2022: € 9.000.000.<br/>
                    Verlies 2021: € 7.000.000.<br/>
                    Van de winst 2022 mag je gebruiken voor verliesverrekening: € 1.000.000 + € 4.000.000 (50% van € 8.000.000) = €
                    5.000.000.<br/>
                    De belastbaar bedrag 2022 wordt dan € 9.000.000 - € 5.000.000 = € 4.000.000<br/>
                    Van het verlies 2021 blijft nog over: € 7.000.000 - € 5.000.000 = € 2.000.000.<br/>
                    Dit verlies mag u verrekenen met de winsten van 2023 en verder.<br/>
                </div>
                <br/>
                <b>Verlies 2022 verrekenen met winst 2021</b>
                <br/>
                Het maximum geldt ook als je een verlies uit 2022 verrekent met de winst van 2021. Voor de voorwaartse verrekening
                van een verlies van vóór 2021 met de winst uit 2021 geldt deze beperking niet.
                <br/><br/>
                <div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <p><u>Voorbeeld</u></p>
                    Verlies 2022: € 9.000.000.<br/>
                    Winst 2021: € 7.000.000.<br/>
                    Verlies 2020: € 1.000.000.<br/>
                    Van de winst 2021 mag je gebruiken voor verliesverrekening: € 1.000.000 + € 3.000.000 (50% van € 6.000.000) = €
                    4.000.000.<br/>
                    Het verlies uit 2020 is volledig verrekend met de winst over 2021. Voor deze verliesverrekening geldt geen
                    beperking.<br/>
                    De verliesverrekeningsruimte bedraagt € 4.000.000. Er is al een verlies uit 2020 verrekend van € 1.000.000. Hierdoor
                    kan van het verlies uit 2022 maar een bedrag van € 3.000.000 worden verrekend met de winst over 2021.
                    het belastbaar bedrag 2021 wordt dan € 7.000.000 - € 1.000.0000 - € 3.000.000 = € 3.000.000.
                    Van het verlies 2022 blijft nog over: € 9.000.000 - € 3.000.000 = € 6.000.000.
                    Dit verlies mag je verrekenen met de winsten over 2023 en verder.
                </div>

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Wanneer verliezen niet verrekenen?
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <br/>
                In bepaalde situaties gelden speciale voorwaarden voor het verrekenen van verliezen. Je kunt bijvoorbeeld geen
                verliezen verrekenen in de volgende situaties:
                <ul>
                    <li>Er treedt een belangenwijziging in de vennootschap op</li>
                    <li>Er is sprake van houdsterverliezen.</li>
                    <li>De fiscale beleggingsinstelling werd in een eerdere periode niet als beleggingsinstelling aangemerkt.</li>
                </ul>
                <b>Voorlopige verliesverrekening</b>
                <br/>
                Lijdt de onderneming in een jaar verlies? En wil je dit verlies verrekenen met winst uit het voorgaande jaar? Dan hoef je niet te
                wachten tot de aangifte over het verliesjaar is afgehandeld. Als je de aangifte indient, kun je een schriftelijk
                verzoek om voorlopige verliesverrekening naar uw belastingkantoor sturen. De Belastingdienst stelt dan de voorlopige
                verliesverrekening vast met een beschikking. Enkele voorwaarden die hierbij gelden:
                <ul>
                    <li>Je dient de aangifte in over het verliesjaar.</li>
                    <li>Er is sprake van houdsterverliezen.</li>
                    <li>De aanslag over het jaar waarmee het verlies wordt verrekend, moet definitief vaststaan.</li>
                </ul>
                Van het verlies dat je aangeeft, wordt maximaal 80% verrekend.
                <br/><br/>
                Bij het vaststellen van de aanslag over het verliesjaar, houdt de Belastingdienst rekening met de eerdere voorlopige
                verliesverrekening.
                <br/><br/>
                <b>Belangenwijziging</b>
                <br/>
                Een belangenwijziging is een verandering in de (middellijke of onmiddellijke) uiteindelijke aandeelhouders van de vennootschap.
                De uiteindelijke aandeelhouders zijn natuurlijke personen en onder bepaalde omstandigheden ook rechtspersonen.
                <br/><br/>
                <b>Verliezen niet langer verrekenbaar bij belangenwijziging</b>
                <br/>
                De verliezen zijn niet langer voorwaarts verrekenbaar als het uiteindelijke belang in de vennootschap voor 30% of meer is gewijzigd.
                Niet langer verrekenen van de verliezen geldt als hoofdregel in de volgende situaties:
                <ul>
                    <li>de bezittingen van de vennootschap bestonden in het verlies- of winstjaar tijdens meer dan 3 maanden voor meer dan 50% uit beleggingen.</li>
                    <li>De activiteiten van de vennootschap zijn direct voor de belangenwijziging afgenomen tot minder dan 30% van de activiteiten bij het begin van het oudste nog te verrekenen verliesjaar.</li>
                    <li>Op het moment van belangenwijziging bestaat het voornemen de activiteiten in de komende 3 jaar te laten inkrimpen tot minder dan 30% van de activiteiten bij het begin van het oudste nog te verrekenen verliesjaar.</li>
                </ul>
                Is alleen de 1e situatie van toepassing? Dan kun je een verzoek doen om de verliezen toch nog voorwaarts te verrekenen met de winst uit werkzaamheden die er al waren tijdens de belangenwijziging.
                <br/><br/>
                <b>Wanneer geen verrekening met vorig jaar?</b>
                <br/>
                Als de vennootschap verlies lijdt na de belangenwijziging, kun je dat verlies in een aantal situaties niet verrekenen met de winst van vóór de belangenwijziging:
                <ul>
                    <li>De activiteiten van de vennootschap zijn gestaakt.</li>
                    <li>De bezittingen van de vennootschap bestonden in het winst- of verliesjaar meer dan 3 maanden voor meer dan 50% uit beleggingen.</li>
                </ul>
                Carry back van verliezen is niet mogelijk als in de vennootschap een nieuwe onderneming is gestart, het belang voor meer dan 30% is overgegaan in andere handen.
                <br/><br/>
                <b>Winst of verlies van het jaar van de belangenwijziging</b>
                <br/>
                In het jaar van de belangenwijziging wordt het resultaat over 2 periodes afzonderlijk berekend. Het gaat om de periode tot aan de belangenwijziging en de resterende periode.
                Als tot aan de belangenwijziging een verlies is geleden, wordt dat direct aan het voorafgaande jaar toegerekend.
                En overeenkomstig wordt een verlies ná de belangenwijziging rechtstreeks bij het volgende jaar in aanmerking genomen.
                <br/><br/>
                <b>Uitzonderingen</b>
                <br/>
                De verliesverrekening wordt bij de volgende belangenwijzigingen niet beperkt:
                <ul>
                    <li>De aandeelhouder is eigenaar geworden van de vennootschap op grond van erfrecht of huwelijksgoederenrecht.</li>
                    <li>De aandeelhouder had aan het begin van het oudste nog te verrekenen verliesjaar al een belang in de vennootschap van minimaal 33 1/3%, en wordt eigenaar van het restant.</li>
                </ul>
                De Belastingdienst stelt de verliezen vast met een beschikking. Tegen deze beschikking kun je bezwaar maken.
                <br/>
                <br/>
                <b>Houdsterverliezen</b>
                <br/>
                Een houdsterverlies is het verlies van een houdster- of financieringsmaatschappij. Je kunt een verlies alleen verrekenen met winsten over jaren waarin de vennootschap ook als houdster- of financieringsmaatschappij actief bent.
                <br/><br/>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingT4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Voorwaarden verliesverrekening
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="headingT4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voor het jaar waarvan de winst voor verrekening wordt gebruikt, geldt bovendien het volgende:<br/>
                <ul>
                    <li>De boekwaarde van het saldo van de vorderingen en schulden op verbonden lichamen mag gedurende (bijna) het gehele boekjaar niet hoger zijn dan de boekwaarde van hetzelfde saldo aan het einde van het verliesjaar.</li>
                    <li>Kun je aannemelijk maken dat de wijziging van het saldo niet overwegend is gericht op de verruiming van de verliesverrekening? Dan kan worden afgeweken van de voorwaarde dat het saldo van het boekjaar niet hoger mag zijn dan het saldo aan het einde van het verliesjaar.</li>
                </ul>
                De Belastingdienst stelt het saldo van de vorderingen en schulden op verbonden lichamen aan het einde van het verliesboekjaar vast met een beschikking. Tegen deze beschikking kun je bezwaar maken.
            </div>
        </div>
    </div>
</div>
